const BaseArchives = () => import('@/components/sanfer/BaseArchives.vue')

const permissionsSanfer = [
  'account_status'
]

export const sanferRoutes = [
  {path: '/account-status', component: BaseArchives, meta: { breadcrumb: 'Estados de Cuenta', requiresAuth: true, permissions: permissionsSanfer } },
]
